<template>
<div>

  <div class="client-container info">

    <!-- NAVBAR .............................................................................. -->
    <item-init-nav-bar parentType="pageInfo"></item-init-nav-bar>

    <!-- TITLE ............................................................................... -->
    <div class="info-box-title-main">
      <div class="info-box-main">
        <div><h1 class="title-h1-bigger theme-light-title-1">Suosittele palvelua <br>ja tienaa rahaa</h1></div>
      </div>
    </div>

    <!-- MAIN ................................................................................ -->
    <div class="info-box-main info-box-1">

      <div class="validation-box validation-error-1 m_b-20"><b>HUOM! Tämä ominaisuus on toistaiseksi poissa käytöstä.</b></div>

      <item-recommend-and-earn-rules-text class="info-box-1_1 c-mist"></item-recommend-and-earn-rules-text>
        
    </div>

  </div>

  <!-- FOOTER ................................................................................ -->
  <item-footer-main></item-footer-main>


  <!-- Just add this whre you need to warch for user's ativity .................................. -->
  <!-- On this page it has to turn this "activity watvhing" on only if user was signed in -->
  <box-user-keep-active v-if="$store.state.userType!=''"></box-user-keep-active>


</div>
</template>


<script> // -------------------------------------------------------------------------------------------------------

import itemInitNavBar                from '@/components/pageInit/itemInitNavBar'
import itemFooterMain                from '@/components/itemFooterMain'
import boxUserKeepActive             from '@/components/boxUserKeepActive'
import itemRecommendAndEarnRulesText from '@/components/itemRecommendAndEarn/itemRecommendAndEarnRulesText'

export default {
  name:        'pageInfoRecommendAndEarn',
  components: {
                itemInitNavBar,
                itemFooterMain,
                boxUserKeepActive,
                itemRecommendAndEarnRulesText
              },

  data () {

    return {

       //signUpShow: false,

    } // return

  }, // data


  // ===========================================================================================================
  created () {
  }, // created


  // ===========================================================================================================
  methods: {
  }, // methods

}
</script>